import React from "react";
import PropTypes from "prop-types";
import { H1, P } from "@arcteryx/components-typography";

export const Success = ({ type, header, description }) => {
  if (type === "Corporate Contact") {
    return <h3>{description}</h3>;
  }

  return (
    <>
      <H1>{header}</H1>
      <P>{description}</P>
    </>
  );
};

Success.defaultProps = {
  header: null
};

Success.propTypes = {
  type: PropTypes.oneOf(["Corporate Contact", "PRO UNIFORM INQUIRY"])
    .isRequired,
  header: PropTypes.string,
  description: PropTypes.string.isRequired
};

export default Success;
